import { z } from 'zod'

import { apiClient, Auth } from '@/shared/api'

import {
  TLandmarkMarker,
  TSubwayMarker,
  TRegionMarker,
  TRoomCountMarker,
  TRoomMarker,
  ZMapBounds,
  ZMapZoomLevel,
  ZSearchFilter,
} from '../model/schema'

export const ZMarkerSearchParams = ZSearchFilter.merge(ZMapBounds).extend({
  uid: z.string().optional(),
  zoomLevel: ZMapZoomLevel,
})

export type TMarkerSearchParams = z.infer<typeof ZMarkerSearchParams>

export type TMarkerResponse = {
  landmarkMarkers: TLandmarkMarker[]
  roomMarkers: TRoomMarker[]
  regionMarkers: TRegionMarker[]
  roomCountMarkers: TRoomCountMarker[]
  subwayMarkers: TSubwayMarker[]
}

export const getMarkers = async (params: TMarkerSearchParams) => {
  const { data } = await apiClient.get<TMarkerResponse>({
    endpoint: `/map/markers`,
    queryParams: params,
    option: {
      cache: 'no-store',
    },
    auth: Auth.OPTIONAL,
  })

  return data
}
